<template>
  <div v-bem="body">
    <i-count-up
      :start="start"
      :end="end"
      :decimals="decimals"
      :duration="duration"
      :options="options"
      :callback="callback"
      ></i-count-up>
    <span v-html="postfix"/>
  </div>
</template>

<script type="text/babel">
  import ICountUp from 'vue-countup-v2'
  export default {
    name: 'CounerUp',
    props: ['start', 'end', 'duration', 'postfix', 'decimals'],
    components: {
      ICountUp
    },
    data () {
      return {
        options: {
          useEasing: true,
          useGrouping: true,
          separator: ' ',
          decimal: ',',
          prefix: '',
          suffix: ''
        }
      }
    },
    methods: {
      callback: function (ins) {
        this.$emit('count-completed')
        // ins.update(ins.endVal + 100)
      }
    }
  }
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/CounterUp.vue